// extracted by mini-css-extract-plugin
export default {"textCenter":"Location_textCenter__LXCy2","textRight":"Location_textRight__4wH8r","textLeft":"Location_textLeft__ZKZPh"};